import type { Status } from "./types-explorer";

export const STORAGE_KEY = "dw_gf_store";

export type StatusMap = Record<string, Status>;

export function loadStatusMap(): StatusMap {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    return JSON.parse(raw) as StatusMap;
  } catch {
    return {};
  }
}

export function saveStatusMap(m: StatusMap): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(m));
  } catch {
    // quota exceeded or storage disabled — silently drop
  }
}

export const ORIGIN_STORAGE_KEY = "dw_gf_origin";

export type PersistedOrigin = {
  originId: string;
  previousOriginId: string;
  geoCoords: { lat: number; lng: number } | null;
};

const DEFAULT_ORIGIN: PersistedOrigin = {
  originId: "loc_mk",
  previousOriginId: "loc_mk",
  geoCoords: null,
};

export function loadOrigin(): PersistedOrigin {
  try {
    const raw = localStorage.getItem(ORIGIN_STORAGE_KEY);
    if (!raw) return DEFAULT_ORIGIN;
    const parsed = JSON.parse(raw) as unknown;
    if (!isPersistedOrigin(parsed)) return DEFAULT_ORIGIN;
    return parsed;
  } catch {
    return DEFAULT_ORIGIN;
  }
}

export function saveOrigin(p: PersistedOrigin): void {
  try {
    localStorage.setItem(ORIGIN_STORAGE_KEY, JSON.stringify(p));
  } catch {
    // quota exceeded or storage disabled — silently drop
  }
}

function isPersistedOrigin(v: unknown): v is PersistedOrigin {
  if (typeof v !== "object" || v === null) return false;
  const o = v as Record<string, unknown>;
  if (typeof o.originId !== "string") return false;
  if (typeof o.previousOriginId !== "string") return false;
  if (o.geoCoords === null) return true;
  if (typeof o.geoCoords !== "object" || o.geoCoords === null) return false;
  const c = o.geoCoords as Record<string, unknown>;
  return typeof c.lat === "number" && typeof c.lng === "number";
}
